import { getWxToken } from '@/assets/api/common';
import wx from 'weixin-js-sdk';
import shareLogo from "@/assets/images/share-logo.png";

const baseShare = {
    title:"科创中国",
    link:location.origin,
    desc:"集技术需求、科技成果、企业服务于一体的技术交易服务平台",
    imgUrl:location.origin + shareLogo
}
let prevShareURL = "",
    isNeedRequestShareURL =true,
    isInital = false;
// 分享的方法
const initShare = (config, shareObj,callback) => {
    let shareData = Object.keys(shareObj).length ?{
        title: shareObj.title,
        link: shareObj.link || shareObj.url,
        desc: shareObj.content || shareObj.desc ||shareObj.subtitle,
        imgUrl: shareObj.img || shareObj.icon ,
        success:function() {
            this.$toast("分享成功");
            callback && callback();
        },
        complete:function(){
            callback && callback();
        }
    }:baseShare;

    // 如果不是以http开头。就在分享地址前加上这个
    if(!/^https?/.test(shareData.link)){
        shareData.link  = location.origin+'/'+shareData.link;
    }
    // 如果imgURL存在。但不是以Http开头的。就用默认的网站logog作为分享图
    if(!/^https?/.test(shareData.imgUrl)){
        shareData.imgUrl = location.origin + shareLogo;
    }
    // 如果内容中包含了一些富文本标签。就使用默认的title来作为分享的主体内容
    if(/<\/?[a-zA-Z]+(\s+[a-zA-Z]+=".*")*>/g.test(shareData.desc)){
        shareData.desc = shareData.title;
    }
    wx.config({
        debug: false,
        appId: config.appId,
        timestamp: config.timestamp,
        nonceStr: config.nonceStr,
        signature: config.signature,
        jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage'
        ]
    });
    wx.ready(function() {
        wx.onMenuShareTimeline(shareData);
        wx.onMenuShareAppMessage(shareData);
    });
}
const getShareConfig = () => {
    let shareURL = location.href.split('#')[0];

    return new Promise((resolve,reject)=>{
        getWxToken({ strURL:encodeURIComponent(shareURL), wxNum: 1 })
            .then(({data})=>{
                resolve(data);
            });
    })

}
export const wxShare = (shareObj,callback) => {
    let currShareURL = shareObj.url || "";
    let isSendShareObj = Object.keys(shareObj).length;
    // let shareConfigURL = "";

    // 判断是否有必要重新获取分享配置信息
    isNeedRequestShareURL = currShareURL != prevShareURL || !isInital;
    // 根据分享的内容不同。传入获取分享token的url
    // shareConfigURL = isSendShareObj?"":location.origin + "/index";
    isInital = true;
    prevShareURL = currShareURL;
    if(isNeedRequestShareURL){
        return getShareConfig()
            .then((config) => {
                initShare(config, shareObj, callback);
                // return 1;
            })
            .catch(()=>{
                console.log("error");
                return 0;
            });
    }
}
// 隐藏分享按钮
export const hideWxShare = ()=>{
    wx.hideMenuItems({
        menuList: ["menuItem:share:appMessage","menuItem:share:timeline"]
    });
}

// 显示分享按钮
export const showWxShare = ()=>{
    wx.showMenuItems({
        menuList: ["menuItem:share:appMessage","menuItem:share:timeline"]
    });
}
